import React from 'react';
import { MessageCircle, Phone, Check } from 'lucide-react';
import { CONTACT, ASSETS } from './Constants';
export function Hero() {
  const trustBullets = ['Orientación confidencial', 'Equipo multidisciplinario', 'Apoyo para personas y familias', 'Sedes en entornos seguros y naturales'];
  return <section id="inicio" className="relative bg-white pt-16 pb-20 lg:pt-24 lg:pb-28 overflow-hidden" data-id="element-135">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-136">
        <div className="lg:grid lg:grid-cols-12 lg:gap-16 items-center" data-id="element-137">
          {/* Text Content */}
          <div className="lg:col-span-6 text-center lg:text-left mb-12 lg:mb-0" data-id="element-138">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-azul tracking-tight mb-6 leading-tight" data-id="element-139">
              Centro de Rehabilitación para Personas con Dependencia a Drogas y
              Alcohol en Chile
            </h1>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-140">
              En Evolución Chile acompañamos procesos de recuperación con un
              equipo multidisciplinario, espacios seguros y orientación cercana
              para personas y familias que necesitan dar el primer paso.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-10" data-id="element-141">
              <a href={CONTACT.whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-3.5 border border-transparent rounded-full shadow-md text-base font-semibold text-white bg-whatsapp hover:bg-whatsapp-hover transition-colors" data-id="element-142">
                <MessageCircle className="w-5 h-5 mr-2" data-id="element-143" />
                Hablar por WhatsApp
              </a>
              <a href={CONTACT.phoneUrl} className="inline-flex items-center justify-center px-8 py-3.5 border-2 border-azul rounded-full text-base font-semibold text-azul hover:bg-azul hover:text-white transition-colors" data-id="element-144">
                <Phone className="w-5 h-5 mr-2" data-id="element-145" />
                Llamar ahora
              </a>
            </div>

            {/* Trust Bullets */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left" data-id="element-146">
              {trustBullets.map((bullet, index) => <div key={index} className="flex items-start" data-id="element-147">
                  <div className="flex-shrink-0 flex items-center justify-center w-5 h-5 rounded-full bg-celeste-light text-azul mt-0.5" data-id="element-148">
                    <Check className="w-3.5 h-3.5" data-id="element-149" />
                  </div>
                  <span className="ml-3 text-sm text-gray-700" data-id="element-150">{bullet}</span>
                </div>)}
            </div>
          </div>

          {/* Image */}
          <div className="lg:col-span-6 relative" data-id="element-151">
            <div className="relative rounded-2xl overflow-hidden shadow-xl aspect-[4/3] lg:aspect-auto lg:h-[500px]" data-id="element-152">
              <img src={ASSETS.photo2} alt="Entorno seguro y natural en Evolución Chile" className="absolute inset-0 w-full h-full object-cover" data-id="element-153" />
              <div className="absolute inset-0 bg-azul/10 mix-blend-multiply" data-id="element-154"></div>
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-celeste-soft rounded-full opacity-50 -z-10" data-id="element-155"></div>
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-celeste-light rounded-full opacity-50 -z-10" data-id="element-156"></div>
          </div>
        </div>
      </div>
    </section>;
}